import { Divider, Drawer, Input, Space, Slider, Checkbox, Button, Select, Spin } from "antd";
import React, { useEffect, useState, useRef } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import PresetPicker from "../../../globals/styles/PresetPicker";
import BMInput from "../../comps/BMInput";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined } from '@ant-design/icons';
import ImageSelect from "../../ImageSelect";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import LinkUI from "../../UI/LinkUI";
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import { AlignCenterIcon, AlignLeftIcon, AlignRightIcon, PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import Html from "../../../utils/Html";
import { previewLink, tt_name_block_warning } from "../../../utils/Utils";
import { fetchImage } from "../../../utils/Api";
import RichTextEditor from "../../UI/RichTextEditor";
import LinkPicker from "../../../globals/styles/LinkPicker";
import MobileSelector from "../../UI/MobileSelector";
export default function TextOverParallax(props) {

    const { containerRef = { current: false }, edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0, view = "desktop", setView = () => { } } = props;
    const [template,] = useTemplate();
    const [content, setContent] = useState(props.content);
    const [mobile, setMobile] = useState(false)


    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = false,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        background_image = "https://bookmanager.com/i/sample_content/default_parallax.jpg",
        background_colour = 0,
        text_container = true,
        text_background_colour = 0,
        text_background_radius = 0,
        height = 600,
        width = 55,
        align = "center",
        text_align = "center",
        bg_padding_x = 0,
        bg_padding_y = 0,
        padding_x = 10,
        padding_y = 10,
        margin_x = 0,
        margin_y = 0,
        vertical_position = "center",
        heading = "Heading...",
        heading_preset = 0,
        paragraph = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit. Sed at tempus ante. Interdum et malesuada fames ac ante ipsum primis in faucibus.",
        paragraph_preset = 0,
        button_url = "",
        button_label = "",
        button_type = 0,
        button_tab = true,
        button_block = false,
        link_id = 0,

        //New
        allow_mobile_overrides = false,
        mobile_vertical_position = "center",
        mobile_bg_height = 600,

        background_alt = ""


    } = data;

    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const linkOut = () => {
        if (button_url) {
            window.open(previewLink(button_url), (button_tab) ? "_blank" : "_self");
        }
    }

    const [offset, setOffset] = useState(0);
    const [visible, setVisible] = useState(false);
    const ref = useRef(null);
    const [ypos, setYpos] = useState(false);
    const [init, setInit] = useState(false);

    useEffect(() => {
        setInit(true);
        if (ref.current && !ypos) {
            const rect = ref.current.getBoundingClientRect();
            setYpos(rect.top)
        }

        const handleScroll = () => {
            if (ypos === false) { return; }
            setOffset(containerRef.current.scrollTop - ypos);
        };

        if (!visible) {
            if (ypos === false) { return; }
            setOffset(containerRef.current.scrollTop - ypos);
            setVisible(true);
        }

        containerRef.current.addEventListener('scroll', handleScroll);
        return () => containerRef.current.removeEventListener('scroll', handleScroll);

    }, [ypos, init]);

    const drawRender = () => {

        let _margin;
        switch (align) {
            case "center":
                _margin = "0 auto";
                break;
            case "right":
                _margin = "0 0 0 auto";
                break;
            default:
                _margin = "0";
                break;
        }

        let _style = {
            margin: _margin,
            maxWidth: (1248 * (width / 100)) + "px",
            alignSelf: "flex-end",
        }

        let _text = {
            background: getColor(text_background_colour, template),
            borderRadius: text_background_radius + "px",
            padding: padding_y + "px " + padding_x + "px",
            margin: margin_y + "px " + margin_x + "px",
            textAlign: text_align,
        }

        let _parallax = {
            height: height + "px",
            width: '100%',
            backgroundAttachment: 'fixed',
            opacity: (!visible) ? "0" : "100",
            display: "flex",
            alignItems: vertical_position,
            backgroundPosition: `50% ${-offset / 5}px`,
            backgroundImage: `url(${fetchImage(background_image)})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            transition: 'background-position 0.0s',
            willChange: 'background-position',
        }

        if (allow_mobile_overrides && view !== "desktop") {
            _parallax.height = mobile_bg_height + "px";
            _parallax.alignItems = mobile_vertical_position;
            _parallax.overflow = "hidden";
        }

        let _align = {
            flexGrow: 1,
        }

        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={{ "padding": bg_padding_y + "px " + bg_padding_x + "px", "background": getColor(background_colour, template) }}>
                    <div ref={ref}
                        style={_parallax}
                    >
                        <div className={(text_container) ? "child-preview-container" : ""} style={_align}>
                            <div style={_style}>
                                <div style={_text}>
                                    {(heading &&
                                        <h2 style={{ "display": "block" }} className={"bm-txt-" + heading_preset} >
                                            {heading}
                                        </h2>
                                    )}
                                    {(paragraph &&
                                        <div className={"bm-component  bm-txt-" + paragraph_preset} >
                                            <Html anchor={"bm-lnkin-" + link_id} html={paragraph} />
                                        </div>
                                    )}
                                    {(button_label &&
                                        <div style={{ "display": "block" }}>
                                            <div className="shim" /><div className="shim" />
                                            <Button block={button_block} onClick={() => linkOut()} className={"bm-btn-" + button_type} >{button_label}</Button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    const drawForm = () => {

        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                <MobileSelector setView={setView} onChange={(e) => setMobile(e)} />
                <div className="shim" /><div className="shim" />
                {/* BACKGROUND VIDEO */}
                {(mobile) ? drawMobile() : drawDesktop()}
            </>
        )

    }

    const drawMobile = () => {

        return (
            <>
                <Checkbox onChange={(e) => setData({ ...data, "allow_mobile_overrides": e.target.checked })} checked={allow_mobile_overrides}><small>Enable Overides?</small></Checkbox>
                <div className="shim" /><div className="shim" />
                <Spin spinning={!allow_mobile_overrides} indicator={<></>}>
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEIGHT</Divider>
                    <div className="float-flex">
                        <BMInput width={"50px"} value={mobile_bg_height} onChange={(e) => setData({ ...data, "mobile_bg_height": e })} number min={100} max={1000} prefix="H" />

                        <Select value={mobile_vertical_position} onChange={(e) => setData({ ...data, "mobile_vertical_position": e })} size="small" style={{ "width": "100%" }} >
                            <Select.Option key="top" value="flex-start"><small>Top</small></Select.Option>
                            <Select.Option key="center" value="center"><small>Centre</small></Select.Option>
                            <Select.Option key="bottom" value="flex-end"><small>Bottom</small></Select.Option>
                        </Select>
                    </div>
                </Spin>
            </>
        )
    }

    const drawDesktop = () => {
        return (
            <>

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEIGHT</Divider>
                <div className="float-flex">
                    <BMInput width={"40px"} value={height} onChange={(e) => setData({ ...data, "height": e })} number min={100} max={1000} prefix="H" />
                </div>
                {/* BACKGROUND PADDING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING</Divider>
                <Space>
                    <BMInput value={bg_padding_x} onChange={(_v) => setData({ ...data, "bg_padding_x": _v })} number min={0} max={100} prefix={<PaddingHorizontalIcon style={{ "color": "#888" }} />} />
                    <BMInput value={bg_padding_y} onChange={(_v) => setData({ ...data, "bg_padding_y": _v })} number min={0} max={100} prefix={<PaddingVerticalIcon style={{ "color": "#888" }} />} />
                </Space>
                <div className="shim" /><div className="shim" />

                {/* BACKGROUND IMAGE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND IMAGE</Divider>
                <ImageSelect require_alt alt={background_alt} onChange={(_v, _alt) => setData({ ...data, "background_image": _v, "background_alt" : _alt })} width={235} path={background_image} />
                <div className="shim" /><div className="shim" />

                {/* BACKGROUND ALT */}
                <div className="shim" />
                <BMInput allow_update value={background_alt} onChange={(e) => setData({ ...data, "background_alt": e })} prefix_width={"50px"} prefix={<nobr>ALT TEXT &nbsp;</nobr>} width={"190px"} placeholder={"Describe the image..."} />
                <div className="shim" /><div className="shim" />

                {/* BACKGROUND IMAGE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={text_background_colour} onChange={(_v) => setData({ ...data, "text_background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT BG BORDER RADIUS</Divider>
                <BMInput width={"40px"} value={text_background_radius} onChange={(e) => setData({ ...data, "text_background_radius": e })} number min={0} max={1000} prefix="R" />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">MAX WIDTH / POSITION</Divider>
                <div className="float-flex">
                    <Slider
                        style={{ "width": "150px" }}
                        min={0}
                        max={100}
                        onChange={(_v) => setData({ ...data, "width": _v })}
                        value={width}
                    />
                    <Space>
                        <div><PicLeftOutlined onClick={() => setData({ ...data, "align": "left" })} style={{ "color": (align === "left") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicCenterOutlined onClick={() => setData({ ...data, "align": "center" })} style={{ "color": (align === "center") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicRightOutlined onClick={() => setData({ ...data, "align": "right" })} style={{ "color": (align === "right") ? "#1890ff" : "#AAA" }} /></div>
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT ALIGN / VERTICAL POSITION</Divider>
                <div className="float-flex">
                    <Space>
                        <div><AlignLeftIcon onClick={() => setData({ ...data, "text_align": "left" })} style={{ "color": (text_align === "left") ? "#1890ff" : "#AAA" }} /></div>
                        <div><AlignCenterIcon onClick={() => setData({ ...data, "text_align": "center" })} style={{ "color": (text_align === "center") ? "#1890ff" : "#AAA" }} /></div>
                        <div><AlignRightIcon onClick={() => setData({ ...data, "text_align": "right" })} style={{ "color": (text_align === "right") ? "#1890ff" : "#AAA" }} /></div>
                    </Space>
                    <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                    <Select value={vertical_position} onChange={(e) => setData({ ...data, "vertical_position": e })} size="small" style={{ "width": "100%" }} >
                        <Select.Option key="top" value="flex-start"><small>Top</small></Select.Option>
                        <Select.Option key="center" value="center"><small>Centre</small></Select.Option>
                        <Select.Option key="bottom" value="flex-end"><small>Bottom</small></Select.Option>
                    </Select>
                </div>
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT PADDING</Divider>
                <div className="float-flex">
                    <Space>
                        <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<PaddingHorizontalIcon style={{ "color": "#888" }} />} />
                        <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<PaddingVerticalIcon style={{ "color": "#888" }} />} />
                    </Space>
                </div>
                <div className="shim" /><div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT MARGIN</Divider>
                <div className="float-flex">
                    <Space>
                        <BMInput value={margin_x} onChange={(_v) => setData({ ...data, "margin_x": _v })} number min={0} max={100} prefix={<PaddingHorizontalIcon style={{ "color": "#888" }} />} />
                        <BMInput value={margin_y} onChange={(_v) => setData({ ...data, "margin_y": _v })} number min={0} max={100} prefix={<PaddingVerticalIcon style={{ "color": "#888" }} />} />
                    </Space>
                </div>
                <div className="shim" /><div className="shim" />
                <div className="group-wrap">
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE PRESET</Divider>
                    <PresetPicker value={heading_preset} onChange={(e) => setData({ ...data, "heading_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE</Divider>
                    <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "heading": e.target.value })} value={heading} placeholder="Headline text..." />
                </div>
                <div className="shim" /> <div className="shim" />
                <div className="group-wrap">
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH PRESET</Divider>
                    <PresetPicker value={paragraph_preset} onChange={(e) => setData({ ...data, "paragraph_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH</Divider>
                    <RichTextEditor container={container} link_id={link_id} background_colour={text_background_colour} padding_x={padding_x} padding_y={padding_y} paragraph_preset={paragraph_preset} text_align={text_align} width={(1248 * (width / 100))} value={paragraph} onChange={(_v) => setData({ ...data, "paragraph": _v })} />
                </div>
                <div className="shim" /> <div className="shim" />
                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON LABEL</Divider>
                <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "button_label": e.target.value })} value={button_label} placeholder="Label..." />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON TYPE</Divider>
                <ButtonPicker value={button_type} onChange={(e) => setData({ ...data, "button_type": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON URL</Divider>
                <LinkUI value={button_url} onChange={(e) => setData({ ...data, "button_url": e })} />
                <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
                <div style={{ "marginTop": "-15px" }} className="float-flex">
                    <Checkbox disabled={(!button_label)} checked={button_block} onChange={(e) => setData({ ...data, "button_block": e.target.checked })} ><small>Fit Container?</small></Checkbox>
                    <Checkbox disabled={(!button_url)} checked={button_tab} onChange={(e) => setData({ ...data, "button_tab": e.target.checked })} ><small>Open in new tab?</small></Checkbox>
                </div>
                <div className="shim" /> <div className="shim" />
                {/* LINK STYLE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK STYLE</Divider>
                <LinkPicker value={link_id} onChange={(e) => setData({ ...data, "link_id": e })} />
                <div className="shim" /> <div className="shim" />
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )
}